import client from "../../external/open-api";
import BaseService from "../base-service";
import ILoggingService from "./logging-service-interface";

export default class LoggingService extends BaseService implements ILoggingService {
    async logInfo(error: string, stackTrace: string): Promise<void> {
        await this.withRetry(() => client.POST(
            "/v{version}/api/log/event",
            {
                params: {
                    path: { version: "1" },
                },
                body: {
                    message: error,
                    stackTrace: stackTrace,
                    created: new Date().toISOString()
                }
            }
        ));
    }
    async logError(error: string, stackTrace: string): Promise<void> {
        await this.withRetry(() => client.POST(
            "/v{version}/api/log/error",
            {
                params: {
                    path: { version: "1" },
                },
                body: {
                    message: error,
                    stackTrace: stackTrace,
                    created: new Date().toISOString()
                }
            }
        ));
    }

}

